import jsonMessages from './resources-en.json';
import { flattenMessages } from './logic/flattenMessages';

export const messages = flattenMessages(jsonMessages);
